import { render } from "./CancelOfferMonthly.vue?vue&type=template&id=6d233d15&ts=true"
import script from "./CancelOfferMonthly.vue?vue&type=script&lang=ts"
export * from "./CancelOfferMonthly.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__